import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
let CharacterSheetHealthCircle = class CharacterSheetHealthCircle extends Vue {
};
__decorate([
    Prop(Number)
], CharacterSheetHealthCircle.prototype, "current", void 0);
__decorate([
    Prop(Number)
], CharacterSheetHealthCircle.prototype, "temporary", void 0);
__decorate([
    Prop(Number)
], CharacterSheetHealthCircle.prototype, "maximum", void 0);
__decorate([
    Prop(Object)
], CharacterSheetHealthCircle.prototype, "tweaks", void 0);
CharacterSheetHealthCircle = __decorate([
    Component({
        components: {
            CharacterSheetTweaker
        }
    })
], CharacterSheetHealthCircle);
export default CharacterSheetHealthCircle;
